import React, { useState } from "react";
import SkeyenoteNotesTable from "./SkeyenoteNotesTable";
import { AddNoteModal, UploadNoteModal } from "./SkeyenoteNotesDialogs";
import { fetchNotes, deleteNote } from "./api/api";
import PageLayout from "../../../components/PageLayout";
import SearchToolbar from "../../../components/SearchToolbar";
import usePageTitle from "../../../services/usePageTitle";
import usePageState from "../../../hooks/usePageState";
import useIsRoleUser from "../../../hooks/useIsRoleUser";
import { extractMsg } from "../../../utils/errorUtils";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import skeyenoteNotesHelp from "../../../content/help/skeyenote-notes.json";

export default function SkeyenoteNotes({ pageTitle = "Skeyenote Notes" }) {
  usePageTitle("SkeyeNote Notes - SkeyeGate™");

  const {
    filteredData,
    loading,
    searchText,
    page,
    pageSize,
    messageApi,
    contextHolder,
    handleSearch,
    clearFilter,
    loadData,
    onPageChange,
  } = usePageState({
    fetchFn: fetchNotes,
    filterFields: [(n) => n.id?.toString(), "path"],
    defaultPageSize: 25,
  });

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const isRoleUser = useIsRoleUser();

  const handleDeleteNote = async (noteId) => {
    try {
      await deleteNote(noteId);
      messageApi.success("Note deleted successfully");
      loadData();
    } catch (error) {
      messageApi.error({
        content: extractMsg(error, "Failed to delete note"),
        key: "delete-note-error",
      });
    }
  };

  const dropdownAdd = !isRoleUser
    ? {
        label: "Add Note",
        icon: <PlusOutlined />,
        items: [
          {
            key: "1",
            label: "Create New Note",
            icon: <PlusOutlined />,
            onClick: () => setAddModalOpen(true),
          },
          {
            key: "2",
            label: "Upload JSON File",
            icon: <UploadOutlined />,
            onClick: () => setUploadModalOpen(true),
          },
        ],
      }
    : null;

  return (
    <div className="skeyenote-notes-page">
      {contextHolder}
      <PageLayout
        title={pageTitle}
        logo="/img/majesteye-icon-skeye-note-square-white-background-no-label"
        description="Manager for Skeyenote notes, allowing you to create, delete, download and access your notes."
        helpContent={skeyenoteNotesHelp}
      >
        <SearchToolbar
          search={searchText}
          onSearchChange={handleSearch}
          onClearFilter={clearFilter}
          dropdownAdd={dropdownAdd}
        />

        <SkeyenoteNotesTable
          data={filteredData}
          loading={loading}
          page={page}
          pageSize={pageSize}
          onPageChange={onPageChange}
          onDeleteNote={handleDeleteNote}
          messageApi={messageApi}
          isRoleUser={isRoleUser}
        />
      </PageLayout>

      <AddNoteModal
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        onSuccess={loadData}
        messageApi={messageApi}
      />
      <UploadNoteModal
        open={uploadModalOpen}
        onClose={() => setUploadModalOpen(false)}
        onSuccess={loadData}
        messageApi={messageApi}
      />
    </div>
  );
}
